import React from "react";
import { CheckBox, NumberBox } from "devextreme-react";

const PasswordSecurity = ({ value, onValueChange }) => {
  return (
    <div className='mb-5'>
      <table className='table table-bordered align-middle mt-1'>
        <thead className='table-dark'>
          <tr>
            <th scope='col'>Setting</th>
            <th scope='col'>Value</th>
            <th scope='col'>Explanation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope='row'>Allow Password Login</th>
            <td className='text-center' style={{ width: "40%" }}>
              <CheckBox
                value={value.enablePasswordLogin}
                onValueChanged={(e) => onValueChange(e, "enablePasswordLogin")}
              />
            </td>
            <td style={{ width: "30%" }}>
              Please do NOT disable password login unless you have set up a
              Single Sign-On integration and have verified that it works
              correctly, and that administrators are still able to log into
              Erply. Otherwise you will lock yourself out of your account.
            </td>
          </tr>
          <tr>
            <th scope='row'>
              An administrator password must contain a special character
            </th>
            <td className='text-center' style={{ width: "40%" }}>
              <CheckBox
                value={value.admin_password_special_character_required}
                onValueChanged={(e) =>
                  onValueChange(e, "admin_password_special_character_required")
                }
              />
            </td>
            <td style={{ width: "30%" }}>
              All Erply passwords must contain one capital letter, one small
              letter and one digit. You can set stricter requirements for
              administrators' passwords. <br /> <br /> An administrator is
              someone who has the permission to manage user groups.
            </td>
          </tr>
          <tr>
            <th scope='row'>Minimum length for an administrator password</th>
            <td className='text-center' style={{ width: "40%" }}>
              <NumberBox
                min={8}
                value={value.admin_password_min_length}
                onValueChanged={(e) =>
                  onValueChange(e, "admin_password_min_length")
                }
              />
            </td>
            <td style={{ width: "30%" }}>
              All Erply passwords must be at least 8 characters long. You can
              require administrators to have longer passwords.
            </td>
          </tr>
          <tr>
            <th scope='row'>All passwords must contain a special character</th>
            <td className='text-center' style={{ width: "40%" }}>
              <CheckBox
                value={value.password_special_character_required}
                onValueChanged={(e) =>
                  onValueChange(e, "password_special_character_required")
                }
              />
            </td>
            <td style={{ width: "30%" }}></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PasswordSecurity;
